import {getCurrentInstance, computed, reactive} from 'vue';
import {ModuleAccountingObjectCache} from '@/stores/moduleConst';
import {useStore} from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheAccountingObjectComboConfig = () => {
  const {proxy} = getCurrentInstance();

  const store = useStore();

  const accountingObjectCombo = computed(() => {
    const accountingObjects = store.getters[`${ModuleAccountingObjectCache}/items`];
    return accountingObjects.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheAccountingObjectComboConfig = reactive({
    data: accountingObjectCombo,
    columns: [
      {
        title: 'Mã đối tượng',
        dataField: 'accounting_object_code',
        width: 125,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên đối tượng',
        dataField: 'accounting_object_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 350,
        flexInQuickSearch: true
      },
      {
        title: 'Mã số thuế',
        dataField: 'company_tax_code',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 125,
      },
    ],
    displayField: 'accounting_object_code',
    valueField: 'accounting_object_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'accounting_object_id',
      titleSearch: 'Tìm nhanh đối tượng',
    },
  });

  return {cacheAccountingObjectComboConfig, accountingObjectCombo};
};
